import { render, staticRenderFns } from "./OrganisationPage.vue?vue&type=template&id=e14f9a3c&scoped=true"
import script from "./OrganisationPage.vue?vue&type=script&lang=ts"
export * from "./OrganisationPage.vue?vue&type=script&lang=ts"
import style0 from "./OrganisationPage.vue?vue&type=style&index=0&id=e14f9a3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e14f9a3c",
  null
  
)

export default component.exports